/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'ca-ui-toolkit',
	'../VisualizationContentContainer',
	'../VisualItem'
], function(
	React,
	PropTypes,
	UI_Toolkit,
	VisualizationContentContainer,
	VisualItem
) {
	const { FlexLayout, FlexItem } = UI_Toolkit;

	class CustomVisualItems extends VisualizationContentContainer {
		constructor(props) {
			super(props);

			this.target = undefined;
			this.targetName = undefined;
			this.state = {
				isContextMenuOpen: false,
				items: this.props.items
			};
		}

		componentWillReceiveProps(nextProps) {
			this.setState({
				items: nextProps.items
			});
		}

		render () {
			const { items } = this.state;
			const { containerClass } = this.props;
			const contentItems = [];
			items.forEach(item => {
				contentItems.push(this.renderVisualizationItem(item));
			});

			return (
				<FlexLayout
					className={containerClass}
					fullHeight
					direction="column"
					justifyContent='flex-start'
				>
					<FlexItem>
						<FlexLayout
							fullHeight
							direction='row'
							wrap='wrap'
						>
							{contentItems}
						</FlexLayout>
					</FlexItem>
				</FlexLayout>
			);
		}

		renderVisualizationItem (item) {
			const { onContextMenuChange, handlers } = this.props;

			return (
				<VisualItem
					item={item}
					handlers={handlers}
					onContextMenuChange={onContextMenuChange}
					openSelectBundleFileDialog = {this.props.handlers.openSelectBundleFileDialog}
					customVisAction={this.props.customVisAction}
				/>
			);
		}
	}

	CustomVisualItems.propTypes = {
		items: PropTypes.array,
		isRefreshing: PropTypes.bool,
		containerClass: PropTypes.string.isRequired,
		itemClass: PropTypes.string.isRequired,
		handlers: PropTypes.shape({
			openSelectBundleFileDialog: PropTypes.func.isRequired
		}).isRequired,
		customVisAction: PropTypes.object.isRequired
	};

	CustomVisualItems.defaultProps = {
		items: [],
		onContextMenuChange: () => {}
	};

	return CustomVisualItems;
});
